export default __webpack_public_path__ + "static/media/add.37f93b95.svg";